import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-4"
          data-testid="error-boundary"
        >
          <div className="max-w-md w-full text-center bg-white rounded-3xl p-8 shadow-sm">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">⚠️</span>
            </div>
            <h1
              className="text-2xl font-bold text-gray-900 mb-2"
              style={{ fontFamily: 'Outfit' }}
              data-testid="error-boundary-title"
            >
              Something went wrong
            </h1>
            <p className="text-gray-600 text-sm mb-6" data-testid="error-boundary-message">
              An unexpected error occurred. You can go back to the app or try again.
            </p>
            {this.state.error?.message && (
              <div
                className="text-xs text-gray-500 bg-gray-50 rounded-lg p-3 mb-6 text-left break-words"
                data-testid="error-boundary-details"
              >
                {this.state.error.message}
              </div>
            )}
            <div className="flex gap-3">
              <button
                onClick={this.handleReset}
                className="flex-1 h-11 rounded-full border border-gray-200 hover:bg-gray-50 font-medium text-gray-700"
                data-testid="error-boundary-retry"
              >
                Try again
              </button>
              <Link
                to="/discover"
                onClick={this.handleReset}
                className="flex-1 h-11 rounded-full bg-[#009E60] hover:bg-[#007A4B] text-white font-medium flex items-center justify-center"
                data-testid="error-boundary-home"
              >
                Go home
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
